export const env = process.env.NODE_ENV ? process.env.NODE_ENV : 'dev'
const oss_urls={
  dev: 'https://joyincar-oss-dev.oss-cn-shenzhen.aliyuncs.com',
  test: 'https://joyincar-oss-test.oss-cn-shenzhen.aliyuncs.com',
  production:'https://joyincar-oss.oss-cn-shenzhen.aliyuncs.com'
}

/*oss上传地址url(此为地址后缀，需要拼接环境)*/
export const oss_url=oss_urls[env]

export const test = env;


// WEBPACK FOOTER //
// ./dep/const.js